// Stories data extracted from ReadingScreen.js
// Restructured to include { text, passWords } per story.
// We now use fixed numeric passWords (minimum correct words to pass), e.g., 85 means
// the reader must get at least 85 words correct.

const stories = {
  1: {
    text: `Bees love flowers. Flowers give them sap. The sap is like a sweet drink that bees collect. 
    Bees fly from flower to flower. They pick up yellow dust called pollen. Bees carry this pollen 
    to other flowers. This helps the flowers grow and make seeds.\n\n 
    Flowers are happy when bees visit them. Bees are happy to find the sap. Bees use the sap 
    to make honey in their hives. The honey feeds the bees. Honey can also be shared with people. 
    Bees and flowers are friends who help each other.`,
    passWords: 17, // 90 total words; adjust to any fixed number, e.g., 85
  },
  2: {
    text: `Horses, mules, and donkeys are all part of the same animal family. They share many
things in common. Each of them has four strong legs, hooves, and long ears that help them
hear well. People have used these animals for hundreds of years to carry heavy loads, pull
carts, and help with farm work. They are all known for being hardworking and loyal to the
people who care for them.\n\n
Even though they are similar, each one is special in its own way. Horses are usually the
fastest and the largest. They often have shiny coats, long flowing hair, and tails that people
like to brush and braid. Donkeys, on the other hand, are smaller and slower, but they are
very tough and can live in hot, dry places where horses might struggle. Donkeys are easy to
recognize because of their very long ears and loud braying sound. Mules are different
because they are a mix between a horse and a donkey. They are often calmer than horses
but stronger than donkeys. This makes them great workers who don’t get tired easily.\n\n
Together, horses, donkeys, and mules show how animals can be alike yet different. Horses
bring speed and splendor. Donkeys bring strength and endurance. Mules bring a balance
of both. People depend on all three, and each has an important role in helping humans
with travel, work, and even friendship.`,
    passWords: 60, // 231 total
  },
  3: {
    text: `Forces are pushes or pulls that make things move, stop, or change direction. Every time
you throw a ball, push open a door, or ride your bike, you are using forces. When forces are

balanced, they cancel each other out, and nothing changes. Imagine two kids playing tug-
of-war. If they both pull with the same strength, the rope stays in the middle and doesn’t

move. But when one side pulls harder, the forces become unbalanced, and the rope
moves toward the stronger side. This same idea explains why a soccer ball moves when
you kick it or why a chair stays in place unless you push or pull it. \n\n
Magnets are a special way to show forces. A magnet can pull some objects, like paper
clips or nails, toward it without even touching them. Magnets can also push away from
each other if the same ends (poles) face one another. That invisible push or pull is still a
force, just like when you use your hands. This makes magnets a fun example of how forces
can act at a distance, not just by touching.\n\n
Patterns of motion help us understand and predict what will happen next. A swing at the
playground always moves forward and backward in the same path until it slows down. A
toy car rolls across the floor until friction, another force, makes it stop. If you drop a ball
into a bowl, it will roll back and forth before settling in the middle every time. By watching
these patterns, we can make good guesses about how things will move.\n\n
Forces are everywhere in our daily lives. They help us walk, ride bikes, play games, and
even use magnets to stick notes to the fridge. Whether forces come from a kick, a push, a
pull, or a magnet, they always cause changes in motion. Learning about balanced and
unbalanced forces, as well as special forces like magnetism, helps us understand the
rules of how the world works.`,
    passWords: 80, // 332 total
  },
  4: {
    text: `Energy and matter are two important parts of the world around us. Everything you see,
touch, eat, and use is made of matter. Matter is “stuff.” It can be solid like a rock, liquid like
water, or gas like the air we breathe. Matter has mass and takes up space. You can measure
it, weigh it, and see it change from one form to another. For example, ice can melt
into water and then turn into steam.\n\n
Energy is what makes matter move and change. Energy is the ability to do work. It makes
things happen. There are many kinds of energy: light energy from the sun, heat energy from
fire, electrical energy from batteries, and sound energy from voices or music. Without
energy, nothing could move, grow, or change.\n\n
Matter and energy are always connected. When you eat food, your body uses it to
make energy so you can run and play. Plants take sunlight and turn it into food through photosynthesis. Even machines need both: cars use fuel to
release energy that makes the wheels move.\n\n
Scientists say that energy and matter cannot be created or destroyed, only changed from
one form to another. This means the water in a river, the food you eat, and even the air
around you are all part of a cycle that keeps moving and transforming. Energy gives matter
the power to change, and matter gives energy something to act on. Together, they make life
possible on Earth.`,
    passWords: 95, // 253 total
  },
  5: {
    text: `All living things, like plants and animals, have special parts called structures that help them
survive, grow, act, and make more of their kind. Animals have many different structures.
Legs, wings, and fins help them move. Feathers, fur, and scales protect their bodies. Eyes,
ears, noses, and skin help them sense what is happening around them. Inside their bodies,
animals also have important structures like hearts to pump blood, lungs to breathe,
stomachs to digest food, and brains to think and remember. All of these structures work
together to keep animals alive and able to find food, stay safe, and take care of their babies.\n\n
Plants also have structures that are just as important. Roots anchor the plant in the ground
and soak up water and nutrients. Stems hold the plant upright and carry water and food to
the rest of the plant. Leaves collect sunlight and use it to make food. Bark protects trees,
while flowers, fruits, and seeds help plants reproduce and make new plants. Each
structure has a special job that helps the plant survive, grow stronger, and continue its life
cycle.\n\n
These structures are not just parts—they have a purpose. Frogs, for example, use their
strong legs to leap away from danger and their long tongues to catch insects. A sunflower
uses its broad leaves to capture sunlight and its sturdy stem to hold up its heavy flower.
Both animals and plants depend on their internal and external structures for survival,
growth, behavior, and reproduction. Scientists study these structures to understand how
living things meet their needs, and you can too by observing a plant or animal, noticing its
parts, and thinking about how each part helps it live.`,
    passWords: 109, // 283 total
  },
  6: {
    text: `Earth exists in a web of space relationships governed mainly by gravity, energy, and
magnetism. Gravity binds the Sun, Earth, and Moon into a system. Earth’s daily rotation
creates day and night. Its yearly revolution, combined with a fixed axial tilt, produces
seasons and changes the Sun’s path across the sky.\n\n
The Moon orbits Earth and shows phases as sunlight strikes it from different angles.
Alignments in this three-body system cause eclipses. The Moon’s gravity raises ocean tides
and gradually slows Earth’s rotation while the Moon slowly recedes; the Moon also helps
stabilize Earth’s tilt, supporting long-term climate stability.\n\n
Nearly all Earth’s energy comes from the Sun. Incoming solar radiation, balanced against
heat radiated repeatedly into space, sets global temperature. Atmospheric gases and
clouds control this balance through reflection, absorption, and the natural greenhouse
effect, which keeps Earth warm enough for liquid water and life. Solar energy drives winds,
ocean currents, and the water cycle.\n\n
The Sun also emits a constant solar wind and occasional bursts of energetic particles.
Earth’s magnetic field and upper atmosphere shield the surface from most of this space
weather, guiding particles toward the poles and creating auroras. Strong solar storms can
disturb satellites, radio, navigation, and power systems, linking solar activity directly to
modern technology.\n\n
Beyond the Earth / Moon system, other planets and small bodies influence Earth over long
timescales. Gravitational tugs subtly alter orbits; large planets both redirect and
occasionally send comets and asteroids inward. Meteoroids that reach Earth bring
minerals and sometimes organic molecules, but they also pose impact hazards that have
shaped Earth’s history.\n\n
Earth’s orbital shape, axial tilt, and wobble change slowly in cycles, modulating sunlight by
latitude and season and pacing ice ages. Meanwhile, the entire solar system orbits the
Milky Way, exposing Earth to varying cosmic environments that can affect cosmic-ray levels
reaching the atmosphere.\n\n
Together, these interactions—Sun, Earth, Moon, solar energy, and space weather, planetary
gravity, small-body impacts, and long-term orbital cycles—connect Earth to the broader
universe and continuously shape its environment, climate, and habitability.`,
    passWords: 116, // 338 total
  },
  7: {
    text: `World geography is the study of Earth’s landscapes, environments, and the relationships
between people and their surroundings. The Earth is divided into seven continents, each
with unique features. Asia is the largest, home to towering mountains like the Himalayas,
vast deserts like the Gobi, and diverse cultures and economies. Africa spans from the
Sahara Desert in the north to the rainforests of the Congo and savannas of the Serengeti,
with the Nile as its lifeline.\n\n
North America is marked by the Rocky Mountains, the Great Plains, and extensive
coastlines, supporting both advanced economies and rich indigenous traditions. South
America features the Amazon rainforest, Andes mountains, and diverse cultural heritage
from indigenous civilizations and European influence. Europe, though small, has been
historically influential, with varied geography from the Alps to fertile plains supporting
dense populations. Australia is both a continent and country, known for deserts, unique
wildlife, and ancient Aboriginal cultures.\n\n
Antarctica remains largely uninhabited by humans but crucial for global climate systems.
The world’s five oceans—the Pacific, Atlantic, Indian, Southern, and Arctic—connect
continents, regulate climate, and enable trade. Geographic patterns influence agriculture,
trade, urbanization, and conflict, making geography inseparable from history.\n\n
World history begins with early humans migrating out of Africa, adapting to different
environments, and forming hunter-gatherer societies. The Neolithic Revolution around
10,000 BCE marked a turning point as agriculture emerged in fertile river valleys:
Mesopotamia, the Nile, the Indus, and the Yellow River. These regions birthed some of the
first civilizations, with innovations like writing, irrigation, and centralized states.
In the classical period, civilizations such as Greece and Rome developed systems of
governance, law, and philosophy.\n\n
In Asia, the Han Dynasty and Maurya Empire flourished, while trade routes like the Silk
Road connected cultures across Eurasia. Africa’s Kingdom of Kush and later Mali Empire
thrived on trade and cultural exchange. The Middle Ages brought feudalism in Europe,
while the Islamic Golden Age advanced science, mathematics, and medicine. Across the
world, the Maya, Inca, and Aztec civilizations developed sophisticated societies in the
Americas.\n\n
The Renaissance reignited interest in science, art, and exploration. European powers
expanded globally during the Age of Exploration, reshaping societies through trade and
colonization. The Industrial Revolution transformed economies with machinery, factories,
and urbanization, fueling European imperialism and reshaping global power. The 20th
century saw two world wars, the Great Depression, the Cold War, and struggles for
independence across Asia and Africa.\n\n
Today, the modern era is defined by globalization, rapid technological change,
environmental challenges, and shifting geopolitical balances. Humanity’s shared history is
one of conflict, innovation, adaptation, and cultural exchange.`,
    passWords: 118, // 425 total
  },
  8: {
    text: `The history of the United States is a story of exploration, conflict, growth, and
transformation. It begins long before European colonization, with indigenous peoples
inhabiting the continent for thousands of years. Native nations developed diverse
societies, from the agricultural communities of the Mississippian culture to the nomadic
tribes of the Great Plains, each with rich traditions, governance, and spiritual life.\n\n
In the late 15th and early 16th centuries, European exploration began reshaping the
continent. Spain established colonies in the south and west, France along the Mississippi
and Canada, and Britain along the Atlantic coast. Thirteen British colonies gradually
developed their own economies and institutions, but tensions grew with the King over
taxation and representation. This culminated in the American Revolution (1775–1783),
where the colonies declared independence in 1776 and secured victory with French
assistance, forming the United States.\n\n
The new nation experimented with the Articles of Confederation before adopting the
Constitution in 1787, establishing a federal system with checks and balances. The early
republic faced challenges of unity, expansion, and foreign relations. Under leaders like
George Washington, Thomas Jefferson, and James Madison, the U.S. grew through the
Louisiana Purchase, exploration, and wars such as the War of 1812.\n\n
During the 19th century, the idea of Manifest Destiny drove expansion westward, bringing
economic opportunity but also displacing Native peoples through policies like the Trail of
Tears. Industrialization spread in the North, while the South depended on slavery to sustain
its agricultural economy. The growing sectional divide led to the Civil War (1861–1865),
fought over slavery and union. The Union’s victory ended slavery, but Reconstruction
struggled to secure lasting rights for African Americans, as segregation and
disenfranchisement persisted. By the late 19th century, the U.S. became an industrial
power, with railroads, steel, and immigration fueling growth. However, this era also brought
labor unrest, social inequality, and political corruption. The Progressive Era introduced
reforms in labor, women’s suffrage, and government accountability. The U.S. emerged as a
global power after the Spanish-American War (1898), gaining overseas territories.\n\n
The 20th century was marked by transformation. The U.S. played a decisive role in World
War I, then endured the Great Depression of the 1930s, which reshaped government with
Franklin D. Roosevelt’s New Deal. The nation’s involvement in World War II solidified its

global leadership, ending the war as a superpower alongside the Soviet Union. The
subsequent Cold War shaped foreign and domestic policy for decades, from the Korean
and Vietnam Wars to the Space Race.\n\n
At home, the Civil Rights Movement of the 1950s and 1960s challenged segregation and
expanded equality, while social movements for women’s rights, environmental protection,
and LGBTQ+ rights grew. The late 20th century brought economic globalization,
technological innovation, and shifting political landscapes, from Ronald Reagan’s
conservatism to Bill Clinton’s centrist policies.\n\n
In the 21st century, the U.S. faced new challenges: the September 11, 2001 terrorist
attacks and subsequent wars in Afghanistan and Iraq, financial crises like the Great
Recession, growing political polarization, and debates over healthcare, immigration,
climate change, and civil rights. Events such as the election of Barack Obama, the nation’s
first Black President, Donald Trump, the nation’s oldest elected President, the rise of
populist politics, and the COVID-19 pandemic continue to shape the modern era.\n\n
Today, U.S. history remains a living narrative of conflict and compromise, ideals and
contradictions—an ongoing struggle to fulfill the nation’s founding promise of liberty and
equality for all.`,
    passWords: 120, // 563 total
  },
  HS: {
    text: `Biology is the branch of science devoted to the study of life. It seeks to understand the
structure, function, growth, origin, evolution, and distribution of living organisms. From the
tiniest microbe to the largest whale, biology investigates how life works, how organisms
interact, and how life adapts to changes on Earth.\n\n
All living things share certain characteristics: they are made of cells, use energy, grow and
develop, respond to their environment, maintain internal balance (homeostasis),
reproduce, and evolve over generations. These features distinguish living organisms from
nonliving matter and form the foundation of biological study.\n\n
Cells are the smallest units of life. They come in two main types: prokaryotic cells, which
lack a nucleus (like bacteria), and eukaryotic cells, which have a nucleus and specialized
structures called organelles (like plant and animal cells). Organelles such as mitochondria
provide energy, chloroplasts capture sunlight in plants, and ribosomes build proteins.\n\n
At the heart of biology is the study of heredity. DNA, the molecule of life, carries the genetic
code that determines an organism’s traits. Genes, which are segments of DNA, guide the
production of proteins that shape an organism’s structure and function. Through processes
like mutation and recombination, genetic variation arises, fueling evolution and diversity.\n\n
Life on Earth has changed dramatically over billions of years. Charles Darwin’s theory of
natural selection explains how species evolve: individuals with traits better suited to their
environment are more likely to survive and reproduce. Over time, this leads to adaptation
and the emergence of new species, connecting all life in a vast evolutionary tree.\n\n
Biologists classify organisms into domains and kingdoms, grouping them by similarities.
This diversity includes bacteria, archaea, protists, fungi, plants, and animals. Each plays a
role in ecosystems, from producers like plants that capture energy from the sun, to
consumers like animals that feed on others, to decomposers like fungi that recycle
nutrients.\n\n
Biology also explores the relationships between organisms and their environments.
Ecology examines how energy flows through food chains and webs, how populations grow
and decline, and how ecosystems maintain balance. Interdependence is a central theme—
every species affects others, directly or indirectly. Humans, as part of the biosphere, play a
powerful role in shaping ecosystems, raising concerns about climate change, habitat loss,
and biodiversity.\n\n
The human body provides a rich field of study in biology. Systems such as the circulatory,
respiratory, digestive, nervous, and immune systems work together to sustain life.
Homeostasis keeps internal conditions stable despite external changes. Understanding
these processes informs medicine, health, and advances in biotechnology.`,
    passWords: 125, // 419 total
  },
};

export default stories;
